<template>
  <div>
    <div class="filters row" style="margin-top: 0">
      <div class="col-1-1">
        <div class="pull-right">
          <button v-on:click="openCreate" class="button button-success button-block">
            <fa-icon icon="plus" />
            Criar
          </button>
        </div>
      </div>
    </div>

    <EmptyState
      v-if="items.length === 0"
      icon="link"
      title="Nenhum webhook cadastrado"
      description="Não há webhooks configurados no momento. Clique em 'Criar' para adicionar um novo endpoint de disparo."
    />

    <div v-else class="table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>#</th>
            <th>Titulo</th>
            <th>URL</th>
            <th>Evento</th>
            <th>Ativo</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.id">
            <td class="highlight">{{ item.id }}</td>
            <td>{{ item.titulo }}</td>
            <td>
              <code style="font-size: 12px">{{ item.url }}</code>
            </td>
            <td>
              <span class="label primary">{{ getEventoDisplay(item.evento) }}</span>
            </td>
            <td>
              <span :class="['label', item.ativo ? 'success' : 'warning']">
                {{ item.ativo ? 'Sim' : 'Nao' }}
              </span>
            </td>
            <td class="actions">
              <button type="button" class="button button-primary" v-on:click="openEdit(item)">
                <fa-icon icon="pencil-alt" />
              </button>
              <button type="button" class="button button-error" v-on:click="deleteConfirm(item.id)">
                <fa-icon icon="trash-alt" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import EmptyState from "../../../components/EmptyState";

export default {
  name: "webhooksTable",
  components: { EmptyState },
  props: ["items", "eventos", "openEdit", "openCreate", "deleteConfirm"],
  methods: {
    getEventoDisplay(eventClass) {
      if (!eventClass || !this.eventos) return eventClass;
      const found = this.eventos.find((e) => e.event === eventClass);
      return found ? found.display : eventClass;
    },
  },
};
</script>
